import React, { Fragment, useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import emailjs from "emailjs-com";
import BlurBoxBackgroundContainer from "../../component/BlurBoxBackgroundContainer";
const useStyles = makeStyles((theme) => ({
  container: {
    height: "auto",
    maxHeight: "inherit",
    marginTop: "-179px",
    marginBottom: "40px",
  },
  box: {
    height: "500px",
    width: "auto",
    margin: "auto",
    padding: "0 24px",
    backgroundColor: "blue",
  },
  form: {
    height: "300px",
    backgroundColor: "yellow",
    width: "auto",
    margin: "auto",
  },
  footer: {
    position: "absolute",
    bottom: "0",
  },
  borderBox: {
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.2))",
    boxShadow: "2px 2px 10px 0 rgba(0, 0, 0, 0.2)",
    width: "inherit",
    height: "1027px",
    paddingTop: "40px",

    [theme.breakpoints.down("sm")]: {
      height: "auto",
      borderRadius: "0px",
      boxShadow: "none",
    },
    [theme.breakpoints.down("s")]: {
      paddingTop: "20px",
      borderRadius: "0px",
      boxShadow: "none",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      paddingTop: "20px",
    },
  },
  contactTitle: {
    marginLeft: "50px",
    [theme.breakpoints.between("sm", "sm")]: {
      marginLeft: "20px",
      marginRight: "20px",
    },
    [theme.breakpoints.down("s")]: {
      marginLeft: "20px",
      marginRight: "20px",
    },
  },
  formBox: {
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0, 0, 0, 0.2)",
    width: "auto",
    height: "800px",
    paddingTop: "30px",
    paddingRight: "55px",
    paddingLeft: "55px",
    marginLeft: "18%",
    marginRight: "18%",
    marginTop: "60px",
    backgroundColor: "white",
    [theme.breakpoints.between("md", "md")]: {
      marginLeft: "20px",
      marginRight: "20px",
    },

    [theme.breakpoints.between("sm", "sm")]: {
      marginTop: "10px",
      height: "auto",
      paddingBottom: "20px",
      marginLeft: "20px",
      marginRight: "20px",
      paddingRight: "15px",
      paddingLeft: "15px",
    },

    [theme.breakpoints.down("s")]: {
      marginTop: "10px",
      marginLeft: "15px",
      marginRight: "15px",
      paddingRight: "15px",
      paddingLeft: "15px",
      height: "900px",
    },
  },
  formInput: {
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0, 0, 0, 0.2)",
    marginBottom: "20px",
  },
  formLabel: {
    marginBottom: "20px",
  },
  formRadio: {
    marginRight: "25px",
    marginLeft: "25px",
    [theme.breakpoints.between("lm", "lm")]: {
      marginRight: "15px",
      marginLeft: "15px",
    },

    [theme.breakpoints.between("md", "md")]: {
      marginRight: "10px",
      marginLeft: "10px",
    },
  },
  button: {
    margin: "0 auto",
    padding: "5px 20px",
    borderRadius: "50px",
    width: "130px",
    display: "block",
  },
}));
export default function ContactUs() {
  const [contact, setContact] = useState("");
  const classes = useStyles();
  const updateContactForm = (e) => {
    e.persist();
    setContact((contact) => ({
      ...contact,
      [e.target.name]: e.target.value,
    }));
  };
  const onSubmit = (e) => {
    e.preventDefault();
    const service_id = "default_service";

    const template_id =
      contact.inquiry === "新規取引について" ? "template_1rn52ts" : "daikoku";
    const userid = "user_STiDv0xWGk2wBdOZ1NF3W";
    emailjs.send(service_id, template_id, contact, userid).then(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.log(error);
      }
    );
    setContact("");
  };
  return (
    <BlurBoxBackgroundContainer background="contactPage--background">
      <Container className={classes.container}>
        <Typography
          color="primary"
          variant="h1"
          className={classes.contactTitle}
          gutterBottom
        >
          お問い合わせ
        </Typography>
        <Box className={classes.borderBox}>
          <Typography
            color="primary"
            variant="h2"
            className={classes.contactTitle}
            gutterBottom
          >
            お問い合わせのご案内
          </Typography>
          <Typography
            variant="body1"
            className={classes.contactTitle}
            gutterBottom
          >
            商品に関することから採用情報まで、お気軽にご相談ください。
          </Typography>
          <form className={classes.formBox} onSubmit={onSubmit}>
            <FormInput
              label="氏名"
              required={true}
              value={contact.name}
              onChange={updateContactForm}
              name="name"
            />
            <FormInput
              label="Eメールアドレス"
              required={true}
              onChange={updateContactForm}
              value={contact.email}
              name="email"
            />
            <FormInput
              label="電話番号"
              required={false}
              onChange={updateContactForm}
              value={contact.number}
              name="number"
            />
            <FormInput
              label="会社名"
              required={false}
              onChange={updateContactForm}
              value={contact.company}
              name="company"
            />
            <FormControl component="fieldset" style={{ marginBottom: "20px" }}>
              <FormLabel component="legend">お問い合わせ内容</FormLabel>
              <RadioGroup
                aria-label="お問い合わせ内容"
                name="inquiry"
                row
                value={contact.inquiry || ""}
                onChange={updateContactForm}
              >
                <FormControlLabel
                  value="商品について"
                  control={<Radio color="primary" />}
                  label="商品について"
                  className={classes.formRadio}
                />
                <FormControlLabel
                  value="新規取引について"
                  control={<Radio color="primary" />}
                  label="新規取引について"
                  className={classes.formRadio}
                />
                <FormControlLabel
                  value="その他"
                  control={<Radio color="primary" />}
                  label="その他"
                  className={classes.formRadio}
                />
              </RadioGroup>
            </FormControl>

            <InputLabel
              required={true}
              className={classes.formLabel}
              htmlFor="my-input"
            >
              お問い合わせ内容の詳細
            </InputLabel>
            <TextField
              className={classes.formInput}
              variant="outlined"
              fullWidth
              multiline={true}
              rows={5}
              name="body"
              value={contact.body || ""}
              onChange={updateContactForm}
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              type="submit"
            >
              送信
            </Button>
          </form>
        </Box>{" "}
      </Container>
    </BlurBoxBackgroundContainer>
  );
}

const FormInput = ({ label, value, onChange, required, name }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <InputLabel
        required={required}
        className={classes.formLabel}
        htmlFor="my-input"
      >
        {label}
      </InputLabel>
      <TextField
        className={classes.formInput}
        id={label}
        fullWidth
        variant="outlined"
        name={name}
        onChange={onChange}
        value={value || ""}
      />
    </Fragment>
  );
};
